import React from "react";

const LeftArrow = () => (
  <svg
    className="w-6 h-6"
    fill="#000000"
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: 48, width: 90 }}
  >
    <path
      fillRule="evenodd"
      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
      clipRule="evenodd"
    />
  </svg>
);

export default LeftArrow;
